export const ATTR_MAP = {'acc': 'Acceptance',
	'bea': 'Beauty',
	'cur': 'Curiosity',
	'eat': 'Eating',
	'fam': 'Family',
	'hon': 'Honor',
	'ide': 'Idealism',
	'ind': 'Independence',
	'ord': 'Order',
	'phy': 'Physical Activity',
	'pow': 'Power',
	'rom': 'Romance',
	'sav': 'Saving',
	'soc': 'Social Contact',
	'sta': 'Status',
	'tra': 'Tranquility',
	'ven': 'Vengeance'
};
export const SD = 1 
export const RELATIONSHIP = 2
export const SPORTS = 3
export const SCHOOL = 810
export const BUSINESS = 4
export const WELLNESS = 5
export const WEAK = -0.841621233
export const STRONG = 0.841621233

export const CLIENT_TOGGLE = 0
export const GROUP_TOGGLE = 1
export const USERS_TOGGLE =  3
export const ME_EDIT_TOGGLE = 2

export const WEAK_COLOR = "#8FCAE7"
export const STRONG_COLOR = "#0065BD"
export const AVERAGE_COLOR = "#F39200"
export const AVERAGE_COLOR_NEG = "#F39200"
export const AVERAGE_COLOR_POS = "#F39201"

export const BAR_CHART_MIN = -2.38
export const BAR_CHART_MAX = 2.38
export function addSign(n) {
	try {	
		n = Number(n).toFixed(2)
		if (n > 0) {
			n = "+" + String(n)
		}
		return ""+ n
} catch (e) {
	console.log('caught')
}
}

export const ATTR_LIST_B = [ "Acceptance", "Beauty", "Curiosity", "Eating", "Family", "Honor", "Idealism", "Independence", "Order", "Physical Activity", "Power", "Saving", "Social Contact", "Status", "Tranquility", "Vengeance"]
export const ATTR_LIST_R = [ "Acceptance", "Curiosity", "Eating", "Family", "Honor", "Idealism", "Independence", "Order", "Physical Activity", "Power", "Romance", "Saving", "Social Contact", "Status", "Tranquility", "Vengeance"]
export const ATTR_LIST_RSMP= [ "Acceptance", "Curiosity", "Family", "Honor", "Idealism", "Independence", "Order", "Physical Activity", "Power", "Social Contact", "Status", "Tranquility", "Vengeance"]

export const vueHtmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}


export let ATTR_MIN_MAX_EXACT = [
	{'name': 'Acceptance', 'low': -2, 'high': 2, 'include': true, 'order': 0, 'value': [-2,2]},
	{'name': 'Beauty', 'low': -2, 'high': 2, 'include': true, 'order': 1, 'value': [-2,2]},
	{'name': 'Curiosity', 'low': -2, 'high': 2, 'include': true, 'order': 2, 'value': [-2,2]},
	{'name': 'Eating', 'low': -2, 'high': 2, 'include': true, 'order': 3, 'value': [-2,2]},
	{'name': 'Family', 'low': -2, 'high': 2, 'include': true, 'order': 4, 'value': [-2,2]},
	{'name': 'Honor', 'low': -2, 'high': 2, 'include': true, 'order': 5, 'value': [-2,2]},
	{'name': 'Idealism', 'low': -2, 'high': 2, 'include': true, 'order': 6, 'value': [-2,2]},
	{'name': 'Independence', 'low': -2, 'high': 2, 'include': true, 'order': 7, 'value': [-2,2]},
	{'name': 'Order', 'low': -2, 'high': 2, 'include': true, 'order': 8, 'value': [-2,2]},
	{'name': 'Physical Activity', 'low': -2, 'high': 2, 'include': true, 'order': 9, 'value': [-2,2]},
	{'name': 'Power', 'low': -2, 'high': 2, 'include': true, 'order': 10, 'value': [-2,2]},
	{'name': 'Romance', 'low': -2, 'high': 2, 'include': true, 'order': 11, 'value': [-2,2]},
	{'name': 'Saving', 'low': -2, 'high': 2, 'include': true, 'order': 12, 'value': [-2,2]},
	{'name': 'Social Contact', 'low': -2, 'high': 2, 'include': true, 'order': 13, 'value': [-2,2]},
	{'name': 'Status', 'low': -2, 'high': 2, 'include': true, 'order': 14, 'value': [-2,2]},
	{'name': 'Tranquility', 'low': -2, 'high': 2, 'include': true, 'order': 15, 'value': [-2,2]},
	{'name': 'Vengeance', 'low': -2, 'high': 2, 'include': true, 'order': 16, 'value': [-2,2]}
]

//export let ATTR_MIN_MAX_SHIFTED = function () { ATTR_MIN_MAX_EXACT.map((a) => a.a}
// TODO: Consolidate these two
export let 	ATTR_MIN_MAX_SHIFTED = [
	{'name': 'Acceptance', 'low': 0, 'high': 3, 'include': true, 'order': 0, 'value': [0,3]},
	{'name': 'Beauty', 'low': 0, 'high': 3, 'include': true, 'order': 1, 'value': [0,3]},
	{'name': 'Curiosity', 'low': 0, 'high': 3, 'include': true, 'order': 2, 'value': [0,3]},
	{'name': 'Eating', 'low': 0, 'high': 3, 'include': true, 'order': 3, 'value': [0,3]},
	{'name': 'Family', 'low': 0, 'high': 3, 'include': true, 'order': 4, 'value': [0,3]},
	{'name': 'Honor', 'low': 0, 'high': 3, 'include': true, 'order': 5, 'value': [0,3]},
	{'name': 'Idealism', 'low': 0, 'high': 3, 'include': true, 'order': 6, 'value': [0,3]},
	{'name': 'Independence', 'low': 0, 'high': 3, 'include': true, 'order': 7, 'value': [0,3]},
	{'name': 'Order', 'low': 0, 'high': 3, 'include': true, 'order': 8, 'value': [0,3]},
	{'name': 'Physical Activity', 'low': 0, 'high': 3, 'include': true, 'order': 9, 'value': [0,3]},
	{'name': 'Power', 'low': 0, 'high': 3, 'include': true, 'order': 10, 'value': [0,3]},
	{'name': 'Saving', 'low': 0, 'high': 3, 'include': true, 'order': 12, 'value': [0,3]},
	{'name': 'Social Contact', 'low': 0, 'high': 3, 'include': true, 'order': 13, 'value': [0,3]},
	{'name': 'Status', 'low': 0, 'high': 3, 'include': true, 'order': 14, 'value': [0,3]},
	{'name': 'Tranquility', 'low': 0, 'high': 3, 'include': true, 'order': 15, 'value': [0,3]},
	{'name': 'Vengeance', 'low': 0, 'high': 3, 'include': true, 'order': 16, 'value': [0,3]}
]


export function fixName(origName) {
	if (origName) {
		let newName = origName.split('+').map((a) => capitalizeFirstLetter(a)).join(' ')
		let newName2 = origName.split(' ').map((a) => capitalizeFirstLetter(a)).join(' ')

		if (newName) {
			return newName
		} else if (newName2) {
			return newName2
		}	else {
			return origName
		}
	}
}

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}


export function configAttrList(attrList, testType) {
	
	let checkedAttrsB = ATTR_LIST_B // [ "Acceptance", "Beauty", "Curiosity", "Eating", "Family", "Honor", "Idealism", "Independence", "Order", "Physical Activity", "Power", "Saving", "Social Contact", "Status", "Tranquility", "Vengeance"]
	let checkedAttrsR = ATTR_LIST_R // [ "Acceptance", "Curiosity", "Eating", "Family", "Honor", "Idealism", "Independence", "Order", "Physical Activity", "Power", "Romance","Saving", "Social Contact", "Status", "Tranquility", "Vengeance"]
	//let checkedAttrsRSMP = ATTR_LIST_RSMP
	
	if (testType === SD) {
		return checkedAttrsR
	 /* let found = attrList.find(function(element) {
		return element === 'Romance';
	  })
	  if (!found) {
		attrList.push('Romance')
	  }*/
	 
	}
	else if (testType === BUSINESS || testType === SPORTS || testType === SCHOOL) {
		return checkedAttrsB
	  /*let found = attrList.find(function(element) {
		return element === 'Beauty';
	  })
	  if (!found) {
		attrList.push('Beauty')
	  }
	}

	return attrList*/
	}
	// if (testType === SCHOOL) {
	// 	return checkedAttrsRSMP
	// }
}



//attrMinMax.push( {'name': 'Beauty', 'low': 0, 'high': 3, 'include': false, 'order': 1})
//attrMinMax.push({'name': 'Romance', 'low': 0, 'high': 3, 'include': true, 'order': 11})


// WEBPACK FOOTER //
// ./src/components/globals/consts.js